export const Config = {
  baseFolder: '/aida/',
  // baseFolder: '/',
  //apiRoot: 'http://localhost:9000/api/v1/',
  apiRoot: 'https://admin.udruzenjeosiguravaca.net/api/v1/',
  // apiRoot: 'https://uosportal.normasoft.net/api/v1/',
  protectionOff: false,
  reCaptchaKey: '6LfIUegnAAAAAHEGLrGVf15ppxIhtSP_vxPRGFcJ'
};

export const currentEventId = 'edb65acb-c55b-490a-9478-f8772212bc07';
// export const currentEventId = 'd3f2317f-db88-4907-bcbe-0753d6a2677d';
